import { forwardRef } from 'react'
import RCTooltip, { TooltipRef } from 'rc-tooltip'
import { TooltipProps } from 'rc-tooltip/lib/Tooltip'

const Tooltip = forwardRef<TooltipRef, TooltipProps>((props, ref) => {
  return <RCTooltip ref={ref} {...props} />
})

export default Tooltip
